import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

// --- CONFIGURAÇÃO ---
// Cole o seu objeto de configuração do Firebase aqui
const firebaseConfig = {
  apiKey: "AIzaSyC2f39qBiZnJQtntyCyt7Y04MkAqXbhbNU",
  authDomain: "portal-msp-ravel.firebaseapp.com",
  projectId: "portal-msp-ravel",
  storageBucket: "portal-msp-ravel.firebasestorage.app",
  messagingSenderId: "1022390035669",
  appId: "1:1022390035669:web:a50ba754a673e953b96e5c"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta as instâncias dos serviços do Firebase para serem usadas noutras partes da aplicação
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);